import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import axiosInstance from "../api/axiosInstance";

interface smslist {
    id?: number;
    name?: string;
}

interface SmsGatewaysState {
    smsgatewaylist: smslist[];
    info: { count: number; current_page: number; limit: number; total_page: number } | null;
    error: string | null;
    loading: boolean;
}


const initialState: SmsGatewaysState = {
    smsgatewaylist: [],
    info: null,
    error: null,
    loading: false,
};

export const GetSmsGateways = createAsyncThunk<
    { data: smslist[]; info: { count: number; current_page: number; limit: number; total_page: number } },
    { search: string; page: number; limit: number },
    { rejectValue: string }
>(
    'smsgatewaylist/GetSmsGateways',
    async ({ search, page, limit }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(`api/admin/gateways`, {
                params: { search, page, limit },
            });
            return { data: response.data.data, info: response.data.info };
        } catch (error: any) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

// Slice
const smsgatewaylistSlice = createSlice({
    name: "smsgatewaylist",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(GetSmsGateways.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GetSmsGateways.fulfilled, (state, action: PayloadAction<{ data: smslist[], info: { count: number; current_page: number; limit: number; total_page: number } }>) => {
                state.loading = false;
                state.smsgatewaylist = action.payload.data;
                state.info = action.payload.info;
            })
            .addCase(GetSmsGateways.rejected, (state, action: PayloadAction<string | undefined>) => {
                state.loading = false;
                state.error = action.payload || 'An error occurred';
            });
    },
});

export default smsgatewaylistSlice.reducer;